import { UpdateDescription } from 'mongodb';
import { Types } from 'mongoose';

export enum CollectionHistoryEventType {
  Created = 'CREATED',
  Edited = 'EDITED',
  SoftDeleted = 'SOFT_DELETED',
  Restored = 'RESTORED',
  Deleted = 'DELETED',
}

export enum CollectionHistoryUserType {
  Investor = 'investor',
  AdminUser = 'adminUser',
  OrgUser = 'orgUser',
  Adviser = 'adviser',
}

export interface HistoryEvent<CollectionFullDocument> {
  docId: Types.ObjectId;
  secondaryId?: Types.ObjectId;
  date: Date;
  eventType: CollectionHistoryEventType;
  user?: {
    adviser?: Types.ObjectId;
    investor?: Types.ObjectId;
    adminUser?: Types.ObjectId;
    orgUser?: Types.ObjectId;
  };
  updatedFields?: UpdateDescription['updatedFields'];
  removedFields?: UpdateDescription['removedFields'];
  fullDocument?: CollectionFullDocument;
  fullDocumentBeforeChange?: CollectionFullDocument;
}

export * as Api from './api';
